@if(currentSection === 'distribution'){
<div>
  <div class="flex-1 px-300-rem py-250-rem">
    <div class="rounded-050">
      <div class="flex flex-col space-y-050-rem">
        <h1 class="text-headline-md-weight-medium text-action-fg-secondary">Distribution</h1>
        <p class="text-container-fg-muted text-label-md-weight-regular">
          Define access permissions and delivery requirements for this update.
        </p>
      </div>
      <div
        class="py-150-rem px-150-rem mt-150-rem rounded-050 bg-container-bg-default border border-container-border-default w-4xl max-w-4xl gap-6 flex flex-col">
        <form [formGroup]="distributionForm">
          <div>
            <h3 class="text-label-lg-weight-medium text-container-fg-default text-[1rem] pb-2">
              Allowed to install by
            </h3>

            <mat-button-toggle-group
              name="mat-button-toggle-group"
              aria-label="access"
              class="*:w-48 *:text-body-md-weight-regular"
              formControlName="access">
              <mat-button-toggle value="Update by CPO">CPO only</mat-button-toggle>
              <mat-button-toggle value="Update by CPO & end-user">CPO & end-user</mat-button-toggle>
            </mat-button-toggle-group>
            @if (showAccessError) {
            <div class="flex gap-2 items-center">
              <i class="icon_marina_ui_CrossContainedOutlined text-feedback-fg-error"></i>
              <mat-error class="text-label-sm-weight-regular text-[12px]"
                >Select who is allowed to install this update</mat-error
              >
            </div>
            }
          </div>

          <h3 class="text-label-lg-weight-medium text-container-fg-default text-[1rem] pt-8">
            Installable via
          </h3>
          <div class="flex flex-col space-y-6 *:space-x-5" formArrayName="companionApps">
            @for (companionApp of companionApps; track companionApp; let i = $index) {

            <div class="flex mt-2" [formGroupName]="i">
              <div class="flex-1">
                <mat-checkbox
                  class="text-body-lg-weight-regular"
                  [class.checkbox-danger]="error && !requireAtLeastOneEnabledCompanionApp()"
                  formControlName="enabled"
                  >{{ companionApp.name }}</mat-checkbox
                >
              </div>

              <div>
                <mat-form-field
                  appearance="outline"
                  class="w-72 no-border-field"
                  [class.border-error]="(getCompanionAppVersionError(companionApp.name, 'iOS') && error === 'emptyCompanionAppVersion') || (isBelowGeneralMinVersion(companionApp.name, 'iOS') && error === 'belowGeneralMinVersion') || (error === 'invalidCompanionAppVersion'
  && isInvalidCompanionAppVersion(companionApp.name, 'iOS'))">
                  <mat-label>iOS minimum version</mat-label>
                  <input
                    matInput
                    placeholder="iOS minimum version"
                    formControlName="appleMinimumVersion" />
                </mat-form-field>
                @if (getCompanionAppVersionError(companionApp.name, 'iOS') && error ===
                'emptyCompanionAppVersion') {
                <div class="flex gap-2 items-center -mt-5">
                  <i class="icon_marina_ui_CrossContainedOutlined text-feedback-fg-error"></i>
                  <mat-error class="text-label-sm-weight-regular text-[10px]"
                    >Enter a minimum iOS version for {{ companionApp.name }}</mat-error
                  >
                </div>
                } @else if (error === 'belowGeneralMinVersion' &&
                isBelowGeneralMinVersion(companionApp.name, 'iOS')) {
                <div class="flex gap-2 items-center -mt-5">
                  <i class="icon_marina_ui_CrossContainedOutlined text-feedback-fg-error"></i>
                  <mat-error class="text-label-sm-weight-regular text-[10px]"
                    >Minimum version must be at least {{ companionApp.appleMinimumVersion }}</mat-error
                  >
                </div>
                } @else if ( error === 'invalidCompanionAppVersion' &&
                isInvalidCompanionAppVersion(companionApp.name, 'iOS')) {
                <div class="flex gap-2 -mt-5 items-center w-[16rem]">
                  <i class="icon_marina_ui_CrossContainedOutlined text-feedback-fg-error"> </i>

                  <mat-error class="text-label-sm-weight-regular text-[10px] leading-tight">
                    Format: Use 2–5 dot-separated numbers only (no suffixes/spaces), e.g., 2.5.0 or
                    2.5.0.123.
                  </mat-error>
                </div>
                }
              </div>

              <div>
                <mat-form-field
                  appearance="outline"
                  class="w-72 no-border-field"
                  [class.border-error]="(getCompanionAppVersionError(companionApp.name, 'Android') && error === 'emptyCompanionAppVersion') || (isBelowGeneralMinVersion(companionApp.name, 'Android') && error === 'belowGeneralMinVersion') || (error === 'invalidCompanionAppVersion'
  && isInvalidCompanionAppVersion(companionApp.name, 'Android'))">
                  <mat-label>Android minimum version</mat-label>
                  <input
                    matInput
                    placeholder="Android minimum version"
                    formControlName="androidMinimumVersion" />
                </mat-form-field>
                @if (getCompanionAppVersionError(companionApp.name, 'Android') && error ===
                'emptyCompanionAppVersion') {
                <div class="flex gap-2 items-center -mt-5">
                  <i class="icon_marina_ui_CrossContainedOutlined text-feedback-fg-error"></i>
                  <mat-error class="text-label-sm-weight-regular text-[10px]"
                    >Enter a minimum Android version for {{ companionApp.name }}</mat-error
                  >
                </div>
                } @else if (error === 'belowGeneralMinVersion' &&
                isBelowGeneralMinVersion(companionApp.name, 'Android')) {
                <div class="flex gap-2 items-center -mt-5">
                  <i class="icon_marina_ui_CrossContainedOutlined text-feedback-fg-error"></i>
                  <mat-error class="text-label-sm-weight-regular text-[10px]"
                    >Minimum version must be at least {{ companionApp.androidMinimumVersion }}</mat-error
                  >
                </div>
                } @else if (error === 'invalidCompanionAppVersion' &&
                isInvalidCompanionAppVersion(companionApp.name, 'Android')) {
                <div class="flex gap-2 -mt-5 items-center w-[16rem]">
                  <i class="icon_marina_ui_CrossContainedOutlined text-feedback-fg-error"> </i>

                  <mat-error class="text-label-sm-weight-regular text-[10px] leading-tight">
                    Format: Use 2–5 dot-separated numbers only (no suffixes/spaces), e.g., 2.5.0 or
                    2.5.0.123.
                  </mat-error>
                </div>
                }
              </div>
            </div>
            }
          </div>
          @if (error && !requireAtLeastOneEnabledCompanionApp()) {
          <div class="flex gap-2 items-center">
            <i class="icon_marina_ui_CrossContainedOutlined text-feedback-fg-error"></i>
            <mat-error class="text-label-sm-weight-regular text-[12px]"
              >Select at least one app</mat-error
            >
          </div>
          }
        </form>
      </div>
    </div>
  </div>
</div>
}
